import { render, staticRenderFns } from "./DormUserMessageDetail.vue?vue&type=template&id=258a7d35&"
import script from "./DormUserMessageDetail.vue?vue&type=script&lang=js&"
export * from "./DormUserMessageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports